import { Button, DatePicker, Form } from "antd";
import { useEffect } from "react";
import DateIcon from "../../../../assets/icons/DateIcon";
import CustomModal from "../../../../components/ui/CustomModal";
import { useCreateBatchForDigigoMutation } from "../../../../features/portal/batch/batchApi";
import useError from "../../../../hooks/useError";
import { disableFutureDates } from "../../../../lib/time";
import { toast } from "../../../../lib/toast";

type Props = {
  open: boolean;
  handleClose: (val?: any) => void;
  data: {
    company_id?: number;
    project_id?: number;
    created_by?: number;
  };
  reRender: () => void;
};

export default function ImportDataDigigoModal({
  handleClose,
  open,
  data,
  reRender,
}: Props) {
  const [createBatchForDigigo, { isLoading, isError, error, isSuccess }] =
    useCreateBatchForDigigoMutation();

  useError(isError, error, "Upload fail");

  const onFinish = (values: any) => {
    const newData = {
      ...data,
      monthYear: values?.monthYear?.format("MM-YYYY"),
    };

    createBatchForDigigo(newData);
  };

  useEffect(() => {
    if (isSuccess) {
      toast("success", "Upload Successfully");
      handleClose();
      reRender();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <CustomModal
      width={500}
      title="Upload from Digigo"
      open={open}
      handleClose={handleClose}
      footer={null}
    >
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        // form={form}
      >
        <Form.Item
          name="monthYear"
          label="Select Month"
          className="mb-1.5"
          rules={[
            {
              required: true,
              message: "Please select month",
            },
          ]}
        >
          <DatePicker
            // defaultValue={dayjs(formatDate(), dateFormat)}
            picker="month"
            format="MMM, YYYY"
            suffixIcon={<DateIcon width={18} height={20} />}
            style={{ width: "100%" }}
            size="large"
            disabledDate={disableFutureDates}
          />
        </Form.Item>

        <div className="flex justify-center items-center mt-4">
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isLoading}
          >
            Submit
          </Button>
        </div>
      </Form>
    </CustomModal>
  );
}
